import AclName from '../AclName.js';

export default [
  AclName.DemoMessageStart,
  AclName.CrmPageSubscriptionPanel,
];
